import React from "react"

export default function ChildSafety() {
  return (
    <div className="w-full h-full">
      <h2><b>Nectar Child Safety & CSAE Policy</b></h2><br/>
      Updated as of Nov 18, 2025<br/><br/>

      <b>Table of Contents</b><br/>
      <ol>
        <li><a href="#introduction">Introduction & Scope</a></li>
        <li><a href="#minors">No Minors Allowed</a></li>
        <li><a href="#csae">Explicit Prohibition of CSAE</a></li>
        <li><a href="#reporting">Reporting & Enforcement</a></li>
        <li><a href="#law-enforcement">Cooperation with Law Enforcement</a></li>
        <li><a href="#controls">Safety Measures & Controls</a></li>
        <li><a href="#changes">Changes to This Policy</a></li>
        <li><a href="#contact">Contact Us</a></li>
      </ol>

      <br/><br/><br/><br/><br/><br/><br/><br/><br/>

      <b><h1 id="introduction">1. Introduction & Scope</h1></b><br/><br/>
      This <b>Child Safety & CSAE (Child Sexual Abuse and Exploitation) Policy</b> applies to the Nectar mobile
      application and related services operated by Jubilee, Inc. (“<b>Nectar</b>,” “<b>Company</b>,” “<b>we</b>,”
      “<b>our</b>,” or “<b>us</b>”). It supplements our <a href="/privacy"><u>Privacy Policy</u></a> and
      <a href="/terms"><u> Terms of Use</u></a> and is intended to set out our published standards to protect
      children and to explicitly prohibit any use of Nectar for child sexual abuse or exploitation (“<b>CSAE</b>”).<br/><br/>
      Nectar is an adult dating and relationship application. While our product is designed and marketed only
      for adults, we recognize the importance of maintaining clear and strict standards related to child safety
      and CSAE. This Policy applies to all users of Nectar and to all content and behavior on the platform.

      <br/><br/>
      <b><h1 id="minors">2. No Minors Allowed</h1></b><br/><br/>
      Nectar is intended <b>only for individuals who are 18 years of age or older</b>.<br/><br/>
      • We do not knowingly allow individuals under 18 to create an account, use the app, or access our services.<br/>
      • By using Nectar, you represent and warrant that you are at least 18 years old.<br/>
      • Any attempt to misrepresent age, or to assist someone under 18 in accessing Nectar, is a violation of this Policy
      and our Terms of Use.<br/><br/>
      If we learn or reasonably suspect that a user is under 18, we may remove or restrict the account and take other
      appropriate actions, which may include reporting to relevant authorities.

      <br/><br/>
      <b><h1 id="csae">3. Explicit Prohibition of CSAE</h1></b><br/><br/>
      Nectar maintains a <b>zero-tolerance policy</b> toward child sexual abuse and exploitation in any form. The following
      are strictly prohibited on Nectar:<br/><br/>
      • Child Sexual Abuse Material (“<b>CSAM</b>”), including any content that depicts or appears to depict a minor
      in a sexual manner or any sexual exploitation of a minor.<br/>
      • Any attempt to create, request, share, distribute, sell, or trade CSAM.<br/>
      • Any behavior, communication, or content that sexualizes minors, including fantasies or role-play that involve
      minors or characters portrayed as minors.<br/>
      • Grooming, solicitation, or attempts to obtain personal information, images, or in-person meetings from anyone
      believed or represented to be under 18.<br/>
      • Any encouragement, facilitation, or promotion of CSAE, trafficking, or exploitation of minors.<br/><br/>
      Violations of this Policy may result in:<br/><br/>
      • Immediate removal of content;<br/>
      • Immediate suspension or permanent ban of the account(s) involved; and<br/>
      • Reporting to law enforcement and relevant child protection organizations, as appropriate.

      <br/><br/>
      <b><h1 id="reporting">4. Reporting & Enforcement</h1></b><br/><br/>
      We strongly encourage users to help keep Nectar safe by reporting any content or behavior that may involve
      child safety concerns or CSAE.<br/><br/>
      • You may report users or content directly in the app where reporting tools are available.<br/>
      • You may also contact us at <a href="mailto:hello@jubileemedia.com">hello@jubileemedia.com</a> if you believe
      a user is under 18, or if you encounter possible CSAM, grooming, or other child safety issues on Nectar.<br/><br/>
      When we receive a report, we may:<br/><br/>
      • Review the reported content and account activity;<br/>
      • Remove content that violates our policies;<br/>
      • Restrict, suspend, or permanently ban user accounts; and<br/>
      • Escalate matters to law enforcement or child protection organizations where required or appropriate.

      <br/><br/>
      <b><h1 id="law-enforcement">5. Cooperation with Law Enforcement</h1></b><br/><br/>
      Nectar cooperates with law enforcement agencies and recognized child protection organizations to investigate and
      prevent CSAE.<br/><br/>
      • Where legally required or appropriate to protect minors, we may preserve and disclose account information,
      usage data, and any relevant content to law enforcement or other competent authorities.<br/>
      • In appropriate cases, we may also submit reports to organizations such as the National Center for Missing
      &amp; Exploited Children (NCMEC) or equivalent entities, consistent with applicable law.<br/><br/>
      Any such sharing of information is conducted in accordance with our <a href="/privacy"><u>Privacy Policy</u></a>
      and applicable data protection and child protection laws.

      <br/><br/>
      <b><h1 id="controls">6. Safety Measures & Controls</h1></b><br/><br/>
      To support this Policy and protect the integrity of Nectar, we may implement and update technical, operational,
      and policy measures, which can include:<br/><br/>
      • Age-gating and age-verification mechanisms intended to limit access to adults.<br/>
      • Content moderation practices (manual, automated, or a combination) to detect and address violations of this
      Policy, including CSAE and other harmful conduct.<br/>
      • Tools that allow users to block, report, and manage interactions with other users.<br/>
      • Internal procedures and training for staff who may review content or handle child safety reports.<br/><br/>
      While we work to maintain a safe environment, no online service can guarantee perfect safety. We encourage all
      users to exercise caution, follow our safety guidelines, and promptly report any concerns.

      <br/><br/>
      <b><h1 id="changes">7. Changes to This Policy</h1></b><br/><br/>
      We may update or amend this Child Safety & CSAE Policy from time to time. When we do, we will post the updated
      Policy at this URL and update the “Updated as of” date at the top of this page. Where required by law, we will
      provide additional notice of changes.<br/><br/>
      Your continued use of Nectar after any changes take effect constitutes your acceptance of the updated Policy.

      <br/><br/>
      <b><h1 id="contact">8. Contact Us</h1></b><br/><br/>
      If you have questions or concerns about this Child Safety & CSAE Policy, or if you need to report a child safety
      issue related to Nectar, you may contact us at:<br/><br/>
      Email Address:<br/>
      <a href="mailto:hello@jubileemedia.com">hello@jubileemedia.com</a><br/><br/>
      Postal Address:<br/>
      Jubilee, Inc.<br/>
      5200 W. Century Blvd., Ste. 704<br/>
      Los Angeles, CA 90045<br/><br/>
      Toll-Free Number:<br/>
      1 (888) 671-4568<br/><br/>
    </div>
  )
}
